export function parseTimestampToken(token: string): Date | null {
  // Accept formats like yyyy_MM_dd_HH_mm_ss or yyyyMMddTHHmmssZ
  if (!token) return null;

  // Try new format: yyyy_MM_dd_HH_mm_ss
  const parts = token.split('_');
  if (parts.length === 6) {
    const [yyyy, MM, dd, HH, mm, ss] = parts;
    const iso = `${yyyy}-${MM}-${dd}T${HH}:${mm}:${ss}Z`;
    const d = new Date(iso);
    if (!isNaN(d.getTime())) return d;
  }

  // Try compact format: yyyyMMddTHHmmssZ
  const compact = token.match(/^(\d{8}T\d{6}Z)$/);
  if (compact) {
    const year = token.substring(0, 4);
    const month = token.substring(4, 6);
    const day = token.substring(6, 8);
    const hour = token.substring(9, 11);
    const minute = token.substring(11, 13);
    const second = token.substring(13, 15);
    const iso = `${year}-${month}-${day}T${hour}:${minute}:${second}Z`;
    const d = new Date(iso);
    if (!isNaN(d.getTime())) return d;
  }

  // Last resort: try Date parse
  const parsed = new Date(token);
  if (!isNaN(parsed.getTime())) return parsed;
  return null;
}
